/*
 *  Cart
 *    Reusable Cart class, used on the cart template and drawer
 *
 *  Version:
 *    1.0.0 - 2023/07/11
 */

import $ from 'jquery';

import { CartQuantitySelector } from './CartQuantitySelector';

import { CartNote, SELECTOR_NOTE } from './CartNote';

import { Slider } from '../../objects/content/Slider'
import { Accordion } from '../../objects/content/Accordion';

import { ProductThumbnailPrint } from '../../objects/product/ProductThumbnailPrint'

import {
  ON_CART_FINISHED, cartRemove, cartGetCurrent, printMoney, 
  cartAdd, jsonFromjQuery, setCartNote
} from '@process-creative/slate-theme-tools';
import { CLASS_OPEN } from '../../tools/constants/classes';

//Selectors
export const CART_PAGE_SELECTOR = "[data-cart-template]";
export const CART_SELECTOR = "[data-cart-selector]";
export const CART_PRODUCT_REMOVE = '[data-cart-remove]';
export const CART_PRODUCTS_CONTAINER = '[data-cart-products]';
export const CART_ITEM_COUNT = '[data-cart-item-count]';
export const CART_ITEM_COUNT_WRAPPER = '[data-cart-item-count-wrapper]';
export const CART_PRODUCT_SELECTOR = 'data-cart-product';
export const CART_SUBTOTAL = '[data-cart-subtotal]';
export const HEADER_CART_COUNTER = '[data-header-cart-counter]';
export const PROMO_TIER_MESSAGE = '[data-cart-progress-tier]';
export const PROMO_TIER_REMAINING = '[data-cart-progress-tier-remaining]';
export const PROMO_TIER_PROGRESS = '[data-cart-progress-tier-progress]';
export const CART_RECOMMENDATIONS = '[data-cart-recommendations]';
export const CART_RECOMMENDATIONS_CONTAINER = '[data-cart-recommendations-container]';
export const CART_PROPERTY_TOGGLE = '[data-property-toggle]';
export const PAGE_MODAL = '[data-modal]';
const SLIDER_SELECTOR = '[data-slider-selector]';
const CART_INFO_ACCORDION = '[data-cart-info-accordion]';
const CART_EMPTY_SELECTOR = '[data-cart-empty]';
const RECOMMENDATIONS_HEADING = '[data-recommendations-heading]';
const ALTERNATE_MONEY = '[data-alternate-money-price]';
const UPSELL_ITEM_SELECTOR = '[data-upsell-item]';
const UPSELL_VARIANT_SELECTOR = '[data-variant-selector]';
const UPSELL_ADD_SELECTOR = '[data-upsell-add]';
const UPSELL_JSON_SELECTOR = '[data-product-json]';
const UPSELL_PRICE_SELECTOR = '[data-product-money]';
const SELECTOR_CHECKOUT_BTN = '[data-checkout-button]';

//Attrs
export const PROMO_TIER_MIN = 'data-cart-progress-tier-min';
export const PROMO_TIER_MAX = 'data-cart-progress-tier-max';
export const SUBSCRIPTION_FREQUENCY = 'shipping_interval_frequency';
export const SLIDE_SELECTOR = 'data-slide-selector';

//Classes
export const CLASS_HAS_NO_ITEMS = 'has-no-items';
export const CLASS_ACTIVE = 'is-active';
export const CLASS_DISABLED = 'is-disabled';
export const CLASS_SUCCESS = 'is-tier-success';
export const CLASS_VISIBLE = 'is-visible';
export const CLASS_HIDDEN = 'is-hidden';
export const CLASS_GIFT = 'is-gift-item';
export const CP = 'c-cart-recommendations';
export const CLASS_PRODUCT_THUMB = 'c-cart-recommended-product o-slider__slide';

export const HIDDEN_PRODUCT_TAG = 'product_hide';
export const SECRET_PRODUCT_TAG = 'Secret Gift';


export class Cart {
  constructor(container) {
    this.container = container;
    this.qtySelectors = [];
    this.inCartProducts = [];

    this.productsContainer = container.find(CART_PRODUCTS_CONTAINER);
    this.subtotal = container.find(CART_SUBTOTAL);
    this.itemsCount = container.find(CART_ITEM_COUNT);
    this.headerCount = $(HEADER_CART_COUNTER);
    this.cartEmptyElem = $(CART_EMPTY_SELECTOR);
    this.cart = $(CART_SELECTOR);
    this.recommendationsHeading = $(RECOMMENDATIONS_HEADING);
    this.alternateMoney = $(ALTERNATE_MONEY);
    this.checkoutButton = container.find(SELECTOR_CHECKOUT_BTN);
    this.propertyToggle = container.find(CART_PROPERTY_TOGGLE);

    // progress bar
    this.cartPromoMessage = container.find(PROMO_TIER_MESSAGE);
    this.cartPromoProgress = container.find(PROMO_TIER_PROGRESS);
    this.cartPromoRemaining = container.find(PROMO_TIER_REMAINING);
    this.cartPromoMin = this.cartPromoMessage.attr(PROMO_TIER_MIN);
    this.cartPromoMax = this.cartPromoMessage.attr(PROMO_TIER_MAX);

    //sliders
    this.sliderClassInstances = []
    container.find(SLIDER_SELECTOR).each((i,e) => {

      // const slider = new Slider($(e))
      // this.sliderClassInstances.push(slider)
    });

    this.recommendedProductsSlider = this.sliderClassInstances.find(slider =>
      slider.container.find(CART_RECOMMENDATIONS).length
    )

    this.cartRecommendationsContainer = container.find(CART_RECOMMENDATIONS_CONTAINER);
    this.cartRecommendations = container.find(CART_RECOMMENDATIONS);

    //accordion
    this.infoAccordionElem = $(CART_INFO_ACCORDION)[0];
    if(this.infoAccordionElem) new Accordion($(this.infoAccordionElem));

    //Cart Notes
    const cartNoteElement = container.find(SELECTOR_NOTE);
    if(cartNoteElement.length) {
      this.cartNotes = new CartNote(cartNoteElement);
    }

    this.setupQuantitySelectors();
    this.setupEditButton();
    // this.fetchRecommendations();

    $(document).on(ON_CART_FINISHED, () => this.onCartFinished());
    container.on('click', CART_PRODUCT_REMOVE, e => this.removeItem(e));
    $(document).on('click', UPSELL_ADD_SELECTOR, e => this.upsellClick(e));
    $(document).on('change', UPSELL_VARIANT_SELECTOR, e => this.variantSelectUpdate(e));
    container.on('click', SELECTOR_CHECKOUT_BTN, e => this.onCheckoutClick(e));
    container.on('click', CART_PROPERTY_TOGGLE, e => this.onPropertyClick(e));

    // Custom event listener
    document.addEventListener('oncartfinished', async (cartData) => {
      this.onCartUpdate(cartData.detail);
      console.log(this);
    });

    // Check if we are editing a preset product
    this.checkPresets();
  }

  checkPresets() {

    const cartDrawerToggle = document.querySelector('[data-cart-drawer-toggle]');
    const urlParams = new URLSearchParams(window.location.search);
    const editValue = urlParams.get('edit');

    if (cartDrawerToggle && editValue) {
      setTimeout(() => {
        cartDrawerToggle.click();
        const targetElement = document.querySelector(`[data-cart-key="${editValue}"] [data-customiser-launch]`);
        targetElement?.click();
      }, 1500);
    }
  }

  async onCartUpdate(cartData) {
    let cart = cartData.cartData;

    const response = await fetch('/cart?view=ajax', {
      method: 'GET'
    });

    let data;

    if (response.ok) {
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        data = await response.json(); // Parse JSON response
      } else {
        data = await response.text(); // Parse text response (possibly HTML)
      }
    }

    let cartContent = data;
    if (!cartContent || !cartContent.length) return;

    //Update HTML of our cart products
    this.productsContainer.html(cartContent);

    //Update the subtotal
    let subtotal = cart.items_subtotal_price;
    this.subtotal.attr('data-money', subtotal);
    this.subtotal.html(printMoney(subtotal));

    let count = cart.item_count;

    if(this.alternateMoney.length) {
      this.alternateMoney.html(printMoney(cart.items_subtotal_price/4));
    }

    //Update content based on cart items
    if (count == 0) {
      this.itemsCount.html('');
      this.headerCount.html('');
      this.headerCount.removeClass(CLASS_VISIBLE);
      this.cart.addClass(CLASS_HAS_NO_ITEMS);
      this.cartEmptyElem.removeClass(CLASS_HIDDEN);
    } else {
      this.itemsCount.html(`${count}`);
      this.headerCount.html(`${count}`);
      this.headerCount.addClass(CLASS_VISIBLE);
      this.cart.removeClass(CLASS_HAS_NO_ITEMS);
    }
    this.sliderClassInstances.forEach(slider => slider.onSlidesUpdated())

    //Update our cart progress bar
    this.updateProgress(subtotal, cart.items);

    //Map array of product IDs in the cart
    this.inCartProducts = cart.items.map(i => i.product_id);

    this.setupQuantitySelectors();
  }
  
  onPropertyClick(e) {
    e.preventDefault();
    
    if (this.propertyToggle) {
      const self = $(e.currentTarget);
      self.toggleClass(CLASS_ACTIVE);
    }
  }

  onCheckoutClick(e) {

    if(this.cartNotes && this.cartNotes.note.length ) {
      const noteValue = this.cartNotes.note.val();

      if(noteValue.length) {
        e.preventDefault();
        this.addCartNote(noteValue);
      }
    }

  }

  async addCartNote(note) {
    await setCartNote(note).then(() => {
      window.location.href = this.checkoutButton.attr('href');
    }).catch(e => console.warn(e));
  }

  onCartFetched(e) {
    this.cartFetching = false;
    //Update the cart elements after we have the content fetched via Ajax
    let cartContent = e;
    if (!cartContent || !cartContent.length) return;
    let cart = cartGetCurrent();

    //Update HTML of our cart products
    this.productsContainer.html(cartContent);

    //Update the subtotal
    let subtotal = cart.items_subtotal_price;
    this.subtotal.attr('data-money', subtotal);
    this.subtotal.html(printMoney(subtotal));

    let count = cart.item_count;

    if(this.alternateMoney.length) {
      this.alternateMoney.html(printMoney(cart.items_subtotal_price/4));
    }

    //Update content based on cart items
    if (count == 0) {
      this.itemsCount.html('');
      this.headerCount.html('');
      this.headerCount.removeClass(CLASS_VISIBLE);
      this.cart.addClass(CLASS_HAS_NO_ITEMS);
      this.cartEmptyElem.removeClass(CLASS_HIDDEN);
    } else {
      this.itemsCount.html(`${count}`);
      this.headerCount.html(`${count}`);
      this.headerCount.addClass(CLASS_VISIBLE);
      this.cart.removeClass(CLASS_HAS_NO_ITEMS);
    }
    this.sliderClassInstances.forEach(slider => slider.onSlidesUpdated())

    //Update our cart progress bar
    this.updateProgress(subtotal, cart.items);

    //Map array of product IDs in the cart
    this.inCartProducts = cart.items.map(i => i.product_id);

    //Find the most expensive item in the cart then fetch recommendations for it
    // let recommendationId = this.mostExpensiveProduct(cart);

    //Fetch and print cart recommendations
    // this.fetchRecommendations(recommendationId);

    //Re-attach Quantity Selectors with their logic.
    this.setupQuantitySelectors();

    //Refresh slider classes, taking into account new content width
    this.sliderClassInstances.forEach(slider => slider.onSlidesUpdated());

    this.showGiftFirst();

    // Close any open modal other than cart drawer within the page
    // $(PAGE_MODAL).removeClass(CLASS_OPEN);
  }

  showGiftFirst() {
    $(CART_PRODUCTS_CONTAINER).find('.' + CLASS_GIFT).each(function(i, el) {
      $(el).insertBefore($(el).prev());
    });
  }


  async onCartFinished() {

    //Are we already fetching?
    //if(this.cartFetching) return;
    //this.cartFetching = true;

    // Fetch the AJAX view for the cart
    const response = await fetch('/cart?view=ajax', {
      method: 'GET'
    });

    if (response.ok) {
      const contentType = response.headers.get('content-type');
      let data;
      
      if (contentType && contentType.includes('application/json')) {
        data = await response.json(); // Parse JSON response
      } else {
        data = await response.text(); // Parse text response (possibly HTML)
      }

      this.onCartFetched(data);
    } else {
      console.error('Failed to fetch the cart', response.statusText);
    }

  }


  async fetchRecommendations(id) {
    if(this.fetchingUpsellProducts) return; //Currently Fetching, return
    id = id || this.mostExpensiveProduct(cartGetCurrent());

    if(!id) {
      this.fetchingUpsellProducts = false;
      return;
    }

    this.fetchingUpsellProducts = true;

    //Fetch recommendations then filter

    let recommendations = await fetch(`/recommendations/products.json?product_id=${id}&limit=10`).then(recommendations => recommendations.json());

    if(!recommendations || recommendations.products.length == 0) {
      this.cartRecommendations.html('');
      this.recommendationsHeading.addClass(CLASS_HIDDEN);
      this.cartRecommendationsContainer.addClass(CLASS_HIDDEN);
      return;
    }

    //Filter out anything in the cart
    recommendations = recommendations.products.filter(i => this.inCartProducts.indexOf(i.id) === -1);

    //Generate recommendations HTML content
    let recommendationContent = recommendations.reduce((x, prod) => {
      if(!prod) return x;
      let v = prod.variants[0];
      let p = prod;

      let url = `/products/${p.handle}?variant=${v.id}`

      let p2 = { ...p }; //Duplicate
      p2.variants = p2.variants.map(variant => {
        let v2 = { ...variant }; //Duplicate
        delete v2.product; //Remove circular reference
        return v2;
      });

      const dataAttributes = SLIDE_SELECTOR;

      //Skip hidden products
      if(prod.tags.indexOf(HIDDEN_PRODUCT_TAG) != -1 || prod.tags.indexOf(SECRET_PRODUCT_TAG) != -1) {
        return x;
      }
      // THUMBNAIL PRINT
      return x += ProductThumbnailPrint(p, p2, v, CLASS_PRODUCT_THUMB, url, dataAttributes, this.cartRecommendations);
    }, '');
    
    this.cartRecommendations.html(recommendationContent);
    this.recommendationsHeading.removeClass(CLASS_HIDDEN);
    this.cartRecommendationsContainer.removeClass(CLASS_HIDDEN);
    
    this.recommendedProductsSlider.onSlidesUpdated()

    setTimeout(() => { 
      this.fetchingUpsellProducts = false; 
    }, 500)
  }

  mostExpensiveProduct(cart) {
    if(!cart) return;
    //Store product IDs in our cart array
    this.inCartProducts = cart.items.map(i => i.product_id);

    let mostExpensive = cart.items.sort((a, b) => b.original_price - a.original_price)[0]
    if(mostExpensive) return mostExpensive.product_id;
  }

  updateProgress(subtotal, items) {
    let remaining = this.cartPromoMax - subtotal;
    let hasSubscription = items.some(i => (i.properties && i.properties[SUBSCRIPTION_FREQUENCY]))

    if(this.cartPromoRemaining.length) {
      this.cartPromoRemaining.attr('data-money', remaining)
      this.cartPromoRemaining.html(printMoney(remaining));
    }

    let percent = parseInt((subtotal / this.cartPromoMax) * 100);
    this.cartPromoProgress.css('width', `${percent}%`);

    if(hasSubscription || subtotal > this.cartPromoMax) {
      this.cartPromoMessage.addClass(CLASS_SUCCESS);
      this.cartPromoMessage.removeClass(CLASS_ACTIVE);
    } else if(subtotal > this.cartPromoMin && subtotal < this.cartPromoMax) {
      this.cartPromoMessage.addClass(CLASS_ACTIVE);
      this.cartPromoMessage.removeClass(CLASS_SUCCESS);
    } else {
      this.cartPromoMessage.removeClass(CLASS_ACTIVE);
      this.cartPromoMessage.removeClass(CLASS_SUCCESS);
    }
  }

  removeItem(e) {
    e.preventDefault();
    e.stopPropagation();

    let self = $(e.currentTarget);
    let product = self.closest(`[${CART_PRODUCT_SELECTOR}]`);
    let index = product.attr('data-index');

    //Now remove Item
    try {
      cartRemove(index);
    } catch (e) {
      console.error(e);
    }

    this.cartData = cartGetCurrent();
    this.onCartFinished();
  }

  setupEditButton() {
    $(document).on('click', '[data-cart-key] [data-customiser-launch]', function (e) {
      const id = $(this).attr('data-customiser-launch');
      const openCustomiser = new CustomEvent('open_customiser', {
        detail: { id }
      });
    
      document.dispatchEvent(openCustomiser);
    });
  }

  setupQuantitySelectors() {
    //Destroy
    this.qtySelectors.forEach(e => e.destroy());

    //Now recreate
    this.qtySelectors = [];

    $(`[${CART_PRODUCT_SELECTOR}]`).each((i,e) => {
      let self = $(e);
      let index = self.attr('data-index');
      this.qtySelectors.push(new CartQuantitySelector(index, self));
    });
  }

  async upsellClick(e) {
    e.preventDefault();

    if (e.currentTarget.hasAttribute('disabled')) {
      return;
    }

    const el = e.target;
    const upsellContainer = el.closest(UPSELL_ITEM_SELECTOR);
    const currVariantEl = upsellContainer?.querySelector(UPSELL_VARIANT_SELECTOR);
    const currVariant = currVariantEl.options[currVariantEl.selectedIndex].value;

    try {
      await cartAdd({ items: [{ id: Number(currVariant), quantity: 1 }] });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  pricing(variant) {
    const PTC = 'o-product-thumbnail';
    return /*html*/`
      ${variant.compare_at_price > variant.price ? /*html*/`
        <span
          class=" ${PTC}__price-price o-product-pricing__compare" 
          data-product-money-compare data-currency
          data-money="${variant.compare_at_price}"
        >
          ${printMoney(variant.compare_at_price)}
        </span>
      `: ''}
      <span
        class=" ${PTC}__price-price o-product-pricing__price" 
        data-product-money data-currency
        data-money="${variant.price}"
      >
        ${printMoney(variant.price)}
      </span>
    `;
  }

  /**
   * Make updates based on new variant update
   */
  onVariantUpdate(upsellContainer, currVariantEl, variant) {
    // Disable button if not available
    const upsellBtn = upsellContainer.querySelector(UPSELL_ADD_SELECTOR);

    if (!variant?.available || !variant) {
      upsellBtn?.setAttribute('disabled', 'disabled');
    } else {
      upsellBtn?.removeAttribute('disabled');
      currVariantEl.value = variant.id.toString();
    }

    // Update price
    const priceContainer = upsellContainer.querySelector(UPSELL_PRICE_SELECTOR);
    if (!priceContainer || !variant) return;

    priceContainer.parentElement.innerHTML = this.pricing(variant);
  }

  variantSelectUpdate(e) {
    let target = e.target;
    const upsellContainer = target.closest(UPSELL_ITEM_SELECTOR);
    const currVariantEl = upsellContainer?.querySelector(UPSELL_VARIANT_SELECTOR);
    const product = jsonFromjQuery($(upsellContainer).find(UPSELL_JSON_SELECTOR));
    
    if (!upsellContainer || !currVariantEl || !product) return;

    // Try and find new variant match
    const variant = product.variants.find(v => v.id === Number(currVariantEl.value));  

    this.onVariantUpdate(upsellContainer, currVariantEl, variant);
  }
}


$(() => $(CART_PAGE_SELECTOR).each((i,e) => new Cart($(e))));